exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__item___jOC4i {\n  display: flex;\n  width: 100%;\n  font-size: 15px;\n  height: 50px;\n  align-items: center; }\n  .style__item___jOC4i > label:first-child {\n    display: flex; }\n\n.style__itemGroup___2X0_o {\n  width: 100%;\n  overflow-x: hidden; }\n\n.style__groupHeader___2SSBO {\n  font-weight: 600;\n  font-size: 14px;\n  color: #1a1a1a;\n  padding: 12px 10px 8px 10px;\n  border-bottom: 1px solid #f0f0f0;\n  margin-bottom: 4px; }\n\n.style__modal___2WzdB > div > div {\n  padding-top: 12px;\n  padding-bottom: 14px; }\n", ""]);

// exports
exports.locals = {
	"item": "style__item___jOC4i",
	"itemGroup": "style__itemGroup___2X0_o",
	"groupHeader": "style__groupHeader___2SSBO",
	"modal": "style__modal___2WzdB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SingleSelectModal/style.scss
// module id = 1715
// module chunks = 6